import { pricingConfig } from '../../config'
import { CheckIcon } from '../shared/icons'

function resolveCta(plan: typeof pricingConfig.plans[number]): string {
  if (plan.waitlist) return 'Join waitlist →'
  if (plan.addon_to) return 'Attach to Founder →'
  return 'Start free →'
}

export function Pricing() {
  const tiers = pricingConfig.plans

  return (
    <section id="pricing" className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <h2 className="text-2xl md:text-3xl font-semibold">Pricing that scales to $5M ARR</h2>
      <p className="text-muted mt-2 max-w-2xl">
        Annual plans get 2 months free. Warm intros unlock only after hitting readiness evidence thresholds so investors trust the signal.
      </p>
      <div className="grid md:grid-cols-3 gap-6 mt-8">
        {tiers.map((plan) => (
          <div key={plan.id} className={`card rounded-2xl border border-border-light bg-surface-light/60 backdrop-blur p-6 ${plan.addon_to ? 'ring-2 ring-brand-glow/60' : ''}`}>
            <div className="flex items-center justify-between">
              <div className="text-lg font-medium">{plan.name}</div>
              <div className="text-2xl">
                ${plan.price_month}
                <span className="text-xs text-muted ml-1">/mo</span>
              </div>
            </div>
            {plan.addon_to && (
              <div className="text-[11px] text-brand-glow mt-1">Requires {plan.addon_to.charAt(0).toUpperCase() + plan.addon_to.slice(1)} plan</div>
            )}
            {plan.waitlist && <div className="text-[11px] text-brand-alert mt-1">Currently on waitlist</div>}
            <ul className="mt-4 space-y-2 text-sm">
              {plan.bullets.map((feature) => (
                <li key={feature} className="flex items-start gap-2">
                  <CheckIcon/>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            <a
              className={`mt-5 inline-flex px-4 py-2 rounded-xl transition ${
                plan.addon_to ? 'bg-cta-gradient text-white hover:opacity-90' : 'border border-border-light text-muted hover:text-ink'
              }`}
              href="#"
            >
              {resolveCta(plan)}
            </a>
          </div>
        ))}
      </div>
    </section>
  )
}
